import { TutorialActionTypes, CompletionState, CompletionData } from 'Types/TutorialTypes';

export const markChapterAsCompleted = (payload: CompletionData) => ({
  type: TutorialActionTypes.MARK_CHAPTER_COMPLETE,
  payload
});

export const setLastChapter = (payload: CompletionData) => ({
  type: TutorialActionTypes.SET_LAST_CHAPTER,
  payload
});


export const setPlaybackSpeedState = (payload: number) => ({
  type: TutorialActionTypes.SET_PLAYBACK_SPEED,
  payload,
});

export const setManualPause = (payload: { manualPause: boolean }) => ({
  type: TutorialActionTypes.SET_MANUAL_PAUSE,
  payload,
});
